import { Control, DeepMap, Path, useWatch } from 'react-hook-form';
import React, { ReactElement } from 'react';
import { FormErrors } from 'components/ui';

export interface FullNameErrorProps<T extends Fields> {
  touched: Partial<DeepMap<T, boolean>>;
  control: Control<T>;
}

interface Fields {
  firstName: string;
  lastName: string;
}

export const FullNameError = <T extends Fields>({
  touched,
  control,
}: FullNameErrorProps<T>): ReactElement | null => {
  const [firstName, lastName] = useWatch<T>({
    name: ['firstName', 'lastName'] as Path<T>[],
    control,
  });

  if ((touched.firstName && !firstName) || (touched.lastName && !lastName))
    return <FormErrors>Please provide your first and last name</FormErrors>;

  return <FormErrors />;
};
